<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-demo__customers-ai">
      <!-- 搜索表单 -->
       
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
         <el-form-item>
          <el-input v-model="dataForm.name" placeholder="姓名" clearable></el-input>
        </el-form-item>
         <el-form-item>
          <el-input v-model="dataForm.phone" placeholder="手机号码" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.mobileMd5Value" placeholder="手机MD5" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.taskId" placeholder="任务ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.rid" placeholder="话单ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.city" filterable clearable placeholder="请选择城市">
            <el-option
              v-for="item in citys"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.grade" filterable clearable placeholder="话单意向">
            <el-option label="A级" value="A"></el-option>
            <el-option label="B级" value="B"></el-option>
            <el-option label="C级" value="C"></el-option>
            <el-option label="D级" value="D"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.isCallSuccess" filterable clearable placeholder="是否呼通">
            <el-option label="是" :value="1"></el-option>
            <el-option label="否" :value="0"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.isPush" filterable clearable placeholder="是否推送">
            <el-option label="未推送" :value="0"></el-option>
            <el-option label="已推送" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            :picker-options="pickerOptions"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="getTimes"
            value-format="yyyy-MM-dd"
            align="right">
          </el-date-picker>
        </el-form-item>
        
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:customersai:export')" type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:customersai:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('sys:customersai:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <!-- 数据表格 -->
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="ID" header-align="center" align="center" width="80" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="name" label="用户姓名" header-align="center" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="phone" label="手机号" header-align="center" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="mobileMd5Value" label="手机号MD5" header-align="center" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="city" label="城市" header-align="center" align="center" width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="sex" label="性别" header-align="center" align="center" width="100" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="taskId" label="任务ID" header-align="center" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="taskName" label="任务名称" header-align="center" align="center" width="150" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="grade" label="话单意向" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.grade" size="small">{{ scope.row.grade }}</el-tag>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="hangupReason" label="挂机原因" header-align="center" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="audio" label="通话录音" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <a v-if="scope.row.audio" :href="scope.row.audio" target="_blank" class="link-type">播放/下载</a>
            <span v-else>-</span>
          </template>
        </el-table-column>

        <el-table-column prop="detail" label="通话内容" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.detail" type="text" @click="handleShowDetail(scope.row.detail)">查看</el-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="duration" label="通话时长(秒)" header-align="center" align="center" width="110"></el-table-column>
        <el-table-column prop="ringDuration" label="振铃时长(秒)" header-align="center" align="center" width="110"></el-table-column>
        
        <el-table-column prop="isCallSuccess" label="是否呼通" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isCallSuccess === 1" type="success" size="small">是</el-tag>
            <el-tag v-else type="danger" size="small">否</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="isCallLoss" label="是否有呼损" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isCallLoss === 1" type="warning" size="small">是</el-tag>
            <el-tag v-else size="small">否</el-tag>
          </template>
        </el-table-column>

      

        <el-table-column prop="isPush" label="是否推送" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isPush === 1" size="small">是</el-tag>
            <el-tag v-if="scope.row.isPush === 0" type="danger" size="small">否</el-tag>
          </template>
        </el-table-column>

        <el-table-column prop="status" label="状态" header-align="center" align="center" width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 1" type="success">有效</el-tag>
            <el-tag v-if="scope.row.status == 0" type="danger">无效</el-tag>
          </template>
        </el-table-column>
         <el-table-column prop="remark" label="备注" header-align="center" align="center" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="ccName" label="跟进用户" header-align="center" align="center" width="120" :show-overflow-tooltip="true"></el-table-column>
        
        <el-table-column prop="callTime" label="拨打时间" header-align="center" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="pushTime" label="上游推送时间" header-align="center" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="pushDate" label="推送小呗时间" header-align="center" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>


       
        <el-table-column prop="createDate" label="创建日期" header-align="center" align="center" width="160" :show-overflow-tooltip="true"></el-table-column>

        <!-- 操作列：仅保留修改和查看详情 -->
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="180">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('sys:customersai:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('sys:customersai:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
            <el-button v-if="$hasPermission('sys:customers:againPush')" type="text" size="small" @click="againPush(scope.row.id)">{{ $t('重推') }}</el-button>
            <el-button type="text" size="small" @click="handleShowParams(scope.row)">其他信息</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>

      <!-- 弹窗: 通话详情 JSON -->
      <el-dialog
        title="通话内容详情"
        :visible.sync="dialogDetailVisible"
        width="50%">
        <pre style="max-height: 400px; overflow-y: auto;">{{ dialogDetailContent }}</pre>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogDetailVisible = false">关 闭</el-button>
        </span>
      </el-dialog>

      <!-- 弹窗: 其他参数 (params, extra_info, ext, bundle) -->
      <el-dialog
        title="其他参数信息"
        :visible.sync="dialogParamsVisible"
        width="50%">
        <el-tabs type="border-card">
          <el-tab-pane label="自定义参数(params)">
             <pre>{{ currentRowParams.params || '无' }}</pre>
          </el-tab-pane>
          <el-tab-pane label="扩展信息(extra_info)">
             <pre>{{ currentRowParams.extraInfo || '无' }}</pre>
          </el-tab-pane>
          <el-tab-pane label="采集节点(ext)">
             <pre>{{ currentRowParams.ext || '无' }}</pre>
          </el-tab-pane>
          <el-tab-pane label="其他字段(bundle)">
             <pre>{{ currentRowParams.bundle || '无' }}</pre>
          </el-tab-pane>
        </el-tabs>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogParamsVisible = false">关 闭</el-button>
        </span>
      </el-dialog>

      <!-- 【新增】引入 修改弹窗组件 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>

    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
// 【新增】引入子组件
import AddOrUpdate from './customersai-add-or-update'

export default {
  mixins: [mixinViewModule],
  components: {
    // 【新增】注册组件
    AddOrUpdate
  },
  data () {
    return {
      // 【新增】控制修改弹窗显示
      addOrUpdateVisible: false,

      dialogDetailVisible: false,
      dialogDetailContent: '',
      dialogParamsVisible: false,
      currentRowParams: {
        params: '',
        extraInfo: '',
        ext: '',
        bundle: ''
      },
      mixinViewModuleOptions: {
        getDataListURL: '/sys/customersai/page',
        getDataListIsPage: true,
        exportURL: '/sys/customersai/export',
        deleteURL: '/sys/customersai',
        deleteIsBatch: true
      },
      dateValue: '',
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '昨天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, 
          {
            text: '过去七天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      }, 
      citys: [],
      dataForm: {
        phone: '',
        name: '',
        sex: '',
        taskId: '',
        mobileMd5Value: '',
        rid: '',
        city: '',
        grade: '',
        isCallSuccess: '',
        isPush: '',
        startDate: '',
        endDate: ''
      }
    }
  },
  async created () {
    if (this.mixinViewModuleOptions.createdIsNeed) {
      this.getCityOptions();
    }
  },
  methods: {
    // 初始化城市下拉框
    async getCityOptions() {
      this.$http.get(`/sys/dict/data/list?dataType=landing_page_city`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.citys = [];
        if (res.data != null) {
          res.data.forEach(element => {
            this.citys.push({label: element.dictLabel, value: element.dictValue})
          })
        }
      }).catch(() => {})
    },
      againPush(id){
    	this.$http.get(`/sys/customersai/againPush/${id}`,id).then(({ data: res }) => {
	        if (res.code !== 200) {
	          return this.$message.error(res.msg)
	        }
	        this.query();
	   }).catch(() => {})         
    },
    // 处理时间范围选择
    getTimes() {
      if (this.dateValue != null && this.dateValue.length === 2) {
        let startDate = new Date(this.dateValue[0])
        let year = startDate.getFullYear();
        let month = String(startDate.getMonth() + 1).padStart(2, '0');
        let day = String(startDate.getDate()).padStart(2, '0');

        let endDate = new Date(this.dateValue[1])
        let e_year = endDate.getFullYear();
        let e_month = String(endDate.getMonth() + 1).padStart(2, '0');
        let e_day = String(endDate.getDate()).padStart(2, '0');
        
        this.dataForm.startDate = `${year}-${month}-${day} 00:00:00`
        this.dataForm.endDate = `${e_year}-${e_month}-${e_day} 23:59:59`
      } else {
        delete this.dataForm.startDate 
        delete this.dataForm.endDate
      }
    },

    // 查看通话详情 JSON
    handleShowDetail(detailJson) {
      try {
        const obj = typeof detailJson === 'string' ? JSON.parse(detailJson) : detailJson;
        this.dialogDetailContent = JSON.stringify(obj, null, 2);
      } catch (e) {
        this.dialogDetailContent = detailJson;
      }
      this.dialogDetailVisible = true;
    },

    // 查看其他参数
    handleShowParams(row) {
      this.currentRowParams = {
        params: row.params,
        extraInfo: row.extraInfo,
        ext: row.ext,
        bundle: row.bundle
      };
      this.dialogParamsVisible = true;
    },

    // 【新增】打开修改弹窗
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.link-type {
  color: #409EFF;
  cursor: pointer;
  &:hover {
    color: #66b1ff;
  }
}
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>